const Language = {
    name: undefined,
    level: undefined
}

export default Language;